export function filterForUniqueInStringArray(arr: string[]) {
  const unique = Array.from(new Set(arr));
  return unique;
}
